import { Navigate, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';

const PrivateRoute = (props) => {
  const location = useLocation();

  if (!localStorage.getItem('monitor-user') || !props.isLoggedin) {
    return <Navigate to="/" state={{ from: location }} />;
  }
  return props.children;
};

const mapState = (state) => ({
  isLoggedin: state.app.user.isLoggedin,
});

const mapDispatch = {};

export default connect(mapState, mapDispatch)(PrivateRoute);
